module.exports = __webpack_public_path__ + "static/media/X1_NORM.ff2e3301.png";